import React from 'react';
import { Props } from '../types';
import { blokToComponent } from '../helpers';

interface HeroFigure {
  size: 'small' | 'medium' | 'large';
  color: string;
  number: number;
  numberPrefix?: string;
  numberSufix?: string;
  description?: string;
}

export const RocheHeroFigure = ({ blok, slot, getComponent }: Props<HeroFigure>) => (
  <roche-hero-figure
    size={blok.size}
    color={blok.color}
    number={blok.number}
    number-prefix={blok.number_prefix}
    number-sufix={blok.number_sufix}
    slot={slot}>
    {blokToComponent({
      getComponent,
      blok: {
        // eslint-disable-next-line no-underscore-dangle
        _uid: `${blok._uid}-description`,
        component: 'roche-richtext',
        text: blok.description,
      },
    })}
  </roche-hero-figure>
);
